export default __webpack_public_path__ + "static/media/safe.a0e44e41.png";